// On muhasebe: nokta masraf + karlilik raporu.
export const MASRAF_KATEGORILERI = [
    'KIRA',
    'ELEKTRIK',
    'SU',
    'INTERNET',
    'BAKIM',
    'TEMIZLIK',
    'PERSONEL',
    'VERGI',
    'SIGORTA',
    'YAKIT',
    'PAZARLAMA',
    'DIGER',
];
function masrafDs(s) {
    const p = new URLSearchParams();
    if (s.noktaId)
        p.set('noktaId', s.noktaId);
    if (s.kategori)
        p.set('kategori', s.kategori);
    if (s.yilBaslangic)
        p.set('yilBaslangic', String(s.yilBaslangic));
    if (s.ayBaslangic)
        p.set('ayBaslangic', String(s.ayBaslangic));
    if (s.yilBitis)
        p.set('yilBitis', String(s.yilBitis));
    if (s.ayBitis)
        p.set('ayBitis', String(s.ayBitis));
    if (s.baslangic)
        p.set('baslangic', s.baslangic);
    if (s.bitis)
        p.set('bitis', s.bitis);
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function masraflariListele(istemci, sorgu = {}) {
    return istemci.istek(`/muhasebe/masraflar${masrafDs(sorgu)}`);
}
export async function masrafOlustur(istemci, giris) {
    return istemci.istek('/muhasebe/masraflar', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function masrafGuncelle(istemci, id, giris) {
    return istemci.istek(`/muhasebe/masraflar/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(giris),
    });
}
export async function masrafSil(istemci, id) {
    return istemci.istek(`/muhasebe/masraflar/${id}`, { method: 'DELETE' });
}
function karlilikDs(s) {
    const p = new URLSearchParams({
        yilBaslangic: String(s.yilBaslangic),
        ayBaslangic: String(s.ayBaslangic),
        yilBitis: String(s.yilBitis),
        ayBitis: String(s.ayBitis),
    });
    if (s.noktaId)
        p.set('noktaId', s.noktaId);
    return `?${p.toString()}`;
}
export async function karlilikOzeti(istemci, sorgu) {
    return istemci.istek(`/muhasebe/karlilik${karlilikDs(sorgu)}`);
}
export async function karlilikTrendi(istemci, sorgu) {
    return istemci.istek(`/muhasebe/karlilik/trend${karlilikDs(sorgu)}`);
}
//# sourceMappingURL=muhasebe.js.map